import React, { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Input,
  Icon,
  Flex,
  FormLabel,
  Text,
  ModalCloseButton,
  Button,
  //Select,
  useColorModeValue,
} from "@chakra-ui/react";
import { useForm, Controller } from "react-hook-form";
import useUpdateNode from "hooks/useUpdateNode";
import { useUpdateUntraceableNode } from "hooks/useUntraceableNode";

function NodeEditModal({
  isOpen,
  onClose,
  onOpen,
  nodeData,
  data,
  groupData,
  entityId,
  setShowCreateGroup,
  traceableDevices = true,
}) {
  const {
    handleSubmit,
    control,
    resetField,
    clearErrors,
    formState: { errors },
    setValue,
  } = useForm();
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const buttonHover = useColorModeValue("brand.600", "brand.400");

  const handleModalClose = () => {
    resetField("name");
    resetField("device_id");
    resetField("ip_address");
    clearErrors();
    onClose();
  };

  useEffect(() => {
    setValue("name", nodeData?.name);
    setValue("device_id", nodeData?.device_id);
    setValue("ip_address", nodeData?.ip_address);
  }, [nodeData, isOpen]);

  const { mutate: updateNode, isLoading } = useUpdateNode(handleModalClose);
  const { mutate: updateUntraceableNode, isLoading: untraceableLoading } =
    useUpdateUntraceableNode(handleModalClose);

  const onSubmit = (data) => {
    if (traceableDevices) {
      updateNode([
        {
          name: data.name,
          ip_address: data.ip_address,
          order: 1,
          id: nodeData?.id,
          group_id: groupData?.id,
          device_id: data.device_id,
          entity_id: entityId,
          node_type_id: nodeData?.node_type_id,
        },
      ]);
    } else {
      updateUntraceableNode([
        {
          name: data.name,
          order: 1,
          id: nodeData?.id,
          group_id: groupData?.id,
          device_id: data.device_id,
          entity_id: entityId,
          node_type_id: nodeData?.node_type_id,
        },
      ]);
    }
  };
  return (
    <>
      <Modal
        isOpen={isOpen}
        blockScrollOnMount={false}
        onClose={handleModalClose}
        size="sm"
      >
        <ModalOverlay />
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalContent>
            <ModalHeader>
              <Flex w="100%" mt="15px" direction="column" alignItems="center">
                <Flex direction="column" width="100%">
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Name<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "10px" }}>
                    <Controller
                      name="name"
                      rules={{ required: true }}
                      control={control}
                      //defaultValue={nodeData?.name}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          ms={{ base: "0px", md: "0px" }}
                          type="name"
                          placeholder="Enter Name"
                          //mb="24px"
                          fontWeight="500"
                          size="lg"
                          {...field}
                        />
                      )}
                    />
                    {errors.name && errors.name?.type === "required" && (
                      <span style={{ color: "red", fontSize: "14px" }}>
                        name is required
                      </span>
                    )}
                  </div>
                </Flex>
                {traceableDevices && (
                  <Flex direction="column" width="100%" pt="10px">
                    <FormLabel
                      ms="4px"
                      fontSize="sm"
                      fontWeight="500"
                      color={textColor}
                      isRequired={traceableDevices}
                      display="flex"
                    >
                      Ip Address<Text color={brandStars}>*</Text>
                    </FormLabel>
                    <div style={{ marginBottom: "20px" }}>
                      <Controller
                        name="ip_address"
                        rules={{ required: traceableDevices }}
                        control={control}
                        //defaultValue={nodeData?.ip_address}
                        render={({ field }) => (
                          <Input
                            fontSize="sm"
                            placeholder="Enter Ip Address"
                            size="lg"
                            defaultValue={nodeData?.ip_address || ""}
                            type="name"
                            {...field}
                          />
                        )}
                      />
                      {errors.ip_address?.type === "required" && (
                        <span style={{ color: "red", fontSize: "14px" }}>
                          ip address is required
                        </span>
                      )}
                    </div>
                  </Flex>
                )}
                <Flex direction="column" width="100%">
                  <FormLabel
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    isRequired={true}
                    display="flex"
                  >
                    Device Id<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <div style={{ marginBottom: "10px" }}>
                    <Controller
                      name={`device_id`}
                      rules={{ required: true }}
                      control={control}
                      //defaultValue={nodeData?.device_id}
                      render={({ field }) => (
                        <Input
                          fontSize="sm"
                          placeholder="Enter Device Id"
                          size="lg"
                          type="name"
                          {...field}
                        />
                      )}
                    />
                    {errors.device_id &&
                      errors.device_id?.type === "required" && (
                        <span style={{ color: "red", fontSize: "14px" }}>
                          device id is required
                        </span>
                      )}
                  </div>
                </Flex>
              </Flex>
            </ModalHeader>
            <Button
              bg="#4318FF"
              variant="brand"
              ml={5}
              mb={10}
              type="submit"
              width="120px"
              isLoading={isLoading || untraceableLoading}
              _hover={{
                bg: isLoading || untraceableLoading ? "blue" : buttonHover,
              }}
            >
              <Text color={"#FFFFFF"}>Save</Text>
            </Button>
            <ModalCloseButton />
          </ModalContent>
        </form>
      </Modal>
    </>
  );
}

export default NodeEditModal;
